// src/router/index.js
import Vue from 'vue';
import Router from 'vue-router';

// 导入组件
import Index from '@/components/index.vue'; // 公共页面
import Login from '@/views/login.vue'; // 登录页
import Register from '@/views/Register.vue'; // 注册页
import Forgot from '@/views/Forgot.vue'; // 忘记密码页
import AllLearningHistory from '@/views/AllLearningHistory.vue'
import AllRecommendedCourses from '@/views/AllRecommendedCourses.vue'
import CourseDetail from '@/views/CourseDetail.vue'

Vue.use(Router);

const router = new Router({
  mode: 'history', // 使用 history 模式
  base: process.env.BASE_URL, // 基础路径
  routes: [
    { path: '/', redirect: '/login' }, // 根路径重定向到登录页面
    { path: '/login', component: Login ,meta: { requiresAuth: true ,title:"学生-登录"}}, // 登录页面
    { path: '/register', component: Register ,meta: { requiresAuth: true ,title:"注册"}}, // 注册页面
    { path: '/forgot', component: Forgot ,meta: { requiresAuth: true ,title:"忘记密码"}}, // 忘记密码页面

    // 导航项对应的页面，添加 meta 属性标识需要身份验证
    { path: '/dashboard', component: Index, meta: { requiresAuth: true ,title:"课程教学"} }, // 课程教学
    { path: '/profile', component: Index, meta: { requiresAuth: true ,title:"个人中心"} }, // 个人中心
    { path: '/diagram', component: Index, meta: { requiresAuth: true ,title:"创建制图"} }, // 创建制图
    { path: '/tasks', component: Index, meta: { requiresAuth: true ,title:"任务管理"} }, // 任务管理
    { path: '/membership', component: Index, meta: { requiresAuth: true ,title:"会员中心"} }, // 会员中心

    // 捕获所有未定义路径并重定向
    { path: '*', redirect: '/login' },

    {
      path: '/learning-history',
      name: 'LearningHistory',
      component: AllLearningHistory,
      meta: {
        title: '学习记录',
        requiresAuth: true
      }
    },
    {
      path: '/recommended-courses',
      name: 'RecommendedCourses',
      component: AllRecommendedCourses,
      meta: {
        title: '推荐课程',
        requiresAuth: true
      }
    },
    {
      path: '/course/:courseId',
      name: 'CourseDetail',
      component: CourseDetail,
      props: true,
      meta: {
        title: '课程详情',
        requiresAuth: true
      }
    }
  ],
});

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const authToken = localStorage.getItem('cloud'); // 获取 token
    if (authToken) {
      to.meta.title && (document.title = to.meta.title);
      next(); // 已登录，允许访问
    } else {
      if (to.path === '/login') {
        next(); // 已经在登录页，直接放行
      } else {
        next('/login'); // 未登录，跳转到登录页
      }
    }
  } else {
    next(); // 不需要验证的页面，直接放行
  }
});


export default router;
